import React, { useState } from "react";
import { 
  Box, TextField, Button, Typography, Paper, CircularProgress, 
  InputAdornment, IconButton 
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { login } from "../../api/auth";
import { useAuth } from "../../context/AuthContext";

export default function LoginPage() {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const { signIn } = useAuth();
  const navigate = useNavigate();

  const onSubmit = async ({ email, password }) => {
    setLoading(true);
    try {
      const { data } = await login(email, password);
      signIn(data.user, data.access, data.refresh);
      toast.success(`Welcome back, ${data.user.full_name}`);
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error(err.response?.data?.error || "Invalid credentials");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#0A0F1E",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        p: 2,
      }}
    >
      <Paper sx={{ p: 4, maxWidth: 420, width: "100%", borderRadius: 3 }}>
        <Box sx={{ mb: 4, textAlign: "center" }}>
          <Typography variant="h5" fontWeight={700}>NetLabs ITS</Typography>
          <Typography variant="body2" color="text.secondary" mt={0.5}>
            Admin Panel — Sign in to continue
          </Typography>
        </Box>

        <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          <TextField
            label="Email"
            type="email"
            fullWidth
            {...register("email", { required: "Email is required" })}
            error={!!errors.email}
            helperText={errors.email?.message}
          />
<TextField
  label="Password"
  type={showPassword ? "text" : "password"}
  fullWidth
  {...register("password", { required: "Password is required" })}
  error={!!errors.password}
  helperText={errors.password?.message}
  slotProps={{
    input: {
      endAdornment: (
        <InputAdornment position="end">
          <IconButton
            onClick={() => setShowPassword((prev) => !prev)}
            edge="end"
            tabIndex={-1}
          >
            {showPassword ? <VisibilityOff /> : <Visibility />}
          </IconButton>
        </InputAdornment>
      ),
    },
  }}
/>          <Button
            type="submit"
            variant="contained"
            size="large"
            fullWidth
            disabled={loading}
            sx={{ mt: 1 }}
          >
            {loading ? <CircularProgress size={22} color="inherit" /> : "Sign In"}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}